import React from "react";
import { NoPicture } from "@components/Common/SvgIcons";
import { handleImageUploadLogic, useTemplateData } from "@constants/template";
import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { RefreshIcon, StyledIconButton } from "@aureskonnect/react-ui";
import { t } from "i18next";
import swal from "@sweetalert/with-react";

import { deleteFile } from "../fileStore";
import { validUploadedTypes } from "../Website/constants";

interface BannerImageProps {
    dataPath: string[];
    type?: "Desktop" | "Mobile";
    title: string;
    size?: string;
}

const BannerImages = React.memo(
    ({ dataPath, type, title, size }: BannerImageProps) => {
        const { getImageName, getImageUrl, iuud } = useTemplateData();
        const imageUrl = getImageUrl([...dataPath], iuud);
        const imageName = getImageName([...dataPath]);

        const path = React.useMemo(() => ["template", ...dataPath], [dataPath]);
        const handleUpload = React.useCallback(
            (e: React.ChangeEvent<HTMLInputElement>) => {
                const file = e.target.files?.[0];
                const input = e.target;

                if (!file) return;

                if (!validUploadedTypes.includes(file.type)) {
                    input.value = "";
                    return swal({
                        icon: "error",
                        content: <p>{t("File type is not valid")}!</p>,
                        buttons: false,
                        timer: 2000,
                    });
                }

                handleImageUploadLogic(
                    path,
                    type,
                    e,
                    templateActions.updateMediaFile
                );

                input.value = "";
            },
            [path, type]
        );

        const handleReset = React.useCallback(() => {
            const emptyData = {
                Url: "",
                Name: "",
                Type: "",
                Extenxion: "",
            };
            templateActions.updateTemplate(path, emptyData);
            const pathKey = path.join(".");
            deleteFile(pathKey);
        }, [path]);

        return (
            <div>
                <div className="image-upload-section">
                    <div>
                        <h6 className="section-text">{t(title)}</h6>
                        <p className="image-specs">
                            {size ? size : "50×50 (img, jpg, jpeg ou png)"}
                        </p>
                    </div>
                    <div className="image-upload-container">
                        {imageUrl !== "" && (
                            <StyledIconButton
                                title={t("Reset")}
                                outline={true}
                                variant="danger"
                                className="m-0 pme_btn_buttonReinitializeTemplate"
                                onClick={handleReset}
                            >
                                <RefreshIcon height={20} width={20} />
                            </StyledIconButton>
                        )}

                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleUpload}
                            className="file-input"
                            id={`${title.toLowerCase()}${dataPath.join(
                                "-"
                            )}-upload`}
                            aria-label="Upload an image"
                        />
                        <label
                            htmlFor={`${title.toLowerCase()}${dataPath.join(
                                "-"
                            )}-upload`}
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <NoPicture
                                height="35px"
                                width="40px"
                                className="flag__clz"
                            />
                            <span>
                                {imageUrl !== "" ? imageName.slice(-15) : ""}
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        );
    }
);

export default BannerImages;
